import i18n from 'i18next';
import React from 'react';
import { UserLang, SUPPORTED_USER_LANG } from '@constants/common';
import { get } from 'lodash';

export const shuffleArray = function (array) {
    var currentIndex = array.length,
        temporaryValue,
        randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};

export const HasWindow = function () {
    const [isWindow, setIsWindow] = React.useState(false);

    React.useEffect(() => {
        setIsWindow(true);

        return () => setIsWindow(false);
    }, []);

    return isWindow;
};

const lookupQuerystring = 'lng';

export const getAppLinkWithCurrentLang = (url) =>
    `${url}&${lookupQuerystring}=${i18n.language}`;

export const getOriginalLocale = (locale) => {
    if (!locale || (locale && locale.length === 0)) return UserLang.German;
    const localeParsed = locale.split('-');
    const localeChecking = localeParsed[0];
    return SUPPORTED_USER_LANG.includes(localeChecking)
        ? localeChecking
        : UserLang.German;
};

export const correctUrlByPageConfiguration = (pageConfiguration) => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!pageConfiguration) return;
    const {
        slug, localizations
    } = pageConfiguration;

    const currentSlug = window.location.pathname.split('/')[2];
    if (slug !== currentSlug) {
        const foundItem = localizations.find(
            (item) => item?.slug === currentSlug
        );
        if (foundItem) {
            const {
                locale, slug: foundItemSlug
            } = foundItem;
            window.location.href = `/${getOriginalLocale(
                locale
            )}/${foundItemSlug}`;
        }
    }
};

export const isHomePage = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    let pathname = window.location.pathname;
    if (pathname.split('/').length === pathname.lastIndexOf('/')) {
        pathname = pathname.slice(0, pathname.length - 1);
    }
    const pathNames = pathname.split('/');
    return [...SUPPORTED_USER_LANG, '/'].includes(
        pathNames[pathNames.length - 1]
    );
};

export const getDataByLang = ({ currentLanguage, key, data }) => {
    switch (currentLanguage) {
        case UserLang.English:
            return get(data, ['aepsyApiEn', key]);
        case UserLang.Italian:
            return get(data, ['aepsyApiIt', key]);
        case UserLang.French:
            return get(data, ['aepsyApiFr', key]);
        case UserLang.German:
        default:
            return get(data, ['aepsyApiDe', key]);
    }
};

export function getCity(locationInfo) {
    if (locationInfo.locations && locationInfo.locations.length > 0) {
        return locationInfo.locations[0].city;
    }

    return null;
}

export function hasOnlineSessionOffered(locationInfo) {
    return locationInfo.onlineSessionOffered;
}

export const getProviderAudioUrl = (providerInfo, currentLang) => {
    if (
        providerInfo.audioMultiLangInfo?.audioUrls &&
        providerInfo.audioMultiLangInfo?.audioUrls?.length > 0
    ) {
        const foundItem = providerInfo.audioMultiLangInfo?.audioUrls.find(
            (item) => item.locale === currentLang
        );
        return get(foundItem, 'content', providerInfo.audioUrl);
    }

    return providerInfo.audioUrl;
};
